import { render, staticRenderFns } from "./PcErrorBullet.vue?vue&type=template&id=6b11a5fa"
import script from "./PcErrorBullet.vue?vue&type=script&lang=js"
export * from "./PcErrorBullet.vue?vue&type=script&lang=js"
import style0 from "./PcErrorBullet.vue?vue&type=style&index=0&id=6b11a5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports